export const FIRST_YEARLY_DELIVERY_DATE = '1/9/2024';
export const DATA_POINTS_LIMIT = 1_000_000;